// extracted by mini-css-extract-plugin
export default {"formInput":"contact_formInput__e6+iR"};